import '../../../polyfills';
import WebpackerReact from 'webpacker-react';

import { VideoPlayer } from '../../../VideoPlayer';

WebpackerReact.setup({ VideoPlayer });
